module.exports = __webpack_public_path__ + "img/background.3eb52eb3.jpg";